import { createSlice } from "@reduxjs/toolkit";
import { ONBOARD_RESELLER } from "../constants";

export const onboardClientSlice = createSlice({
  name: ONBOARD_RESELLER,
  initialState: {},
  reducers: {
    addResellerDataAction: (state, action) => {
      const data = {
        ...state,
        ...action.payload,
      };

      return (state = data);
    },

    removeResellerData: (state, action) => {
      return (state = {});
    },
  },
});

export const { addResellerDataAction } = onboardClientSlice.actions;
export const { removeResellerData } = onboardClientSlice.actions;

export default onboardClientSlice.reducer;
